import { Workflow, WorkflowId } from '@ply-io/ply-front-shared-utilities';

import {
	allWorkflows as allWorkflowsGetter,
	getWorkflow as getWorkflowGetter,
	hasWorkflowEditGeneralConfigurationPermissions as hasWorkflowEditGeneralConfigurationPermissionsGetter,
	hasWorkflowDeletePermissions as hasWorkflowDeletePermissionsGetter,
	hasWorkflowEditPermissions as hasWorkflowEditPermissionsGetter,
	isLoadingWorkflowGraph,
	canEditWorkflow,
} from '@/store/modules/workflows/getters';
import { useStore } from '@/utils/store';

export const useWorkflowsGetters = () => {
	const { getter } = useStore();
	return {
		allWorkflows: getter<Workflow[]>(allWorkflowsGetter),
		getWorkflow: getter<(id: WorkflowId) => Workflow | undefined>(getWorkflowGetter),
		hasWorkflowEditGeneralConfigurationPermissions: getter<(workflowId: WorkflowId) => boolean>(
			hasWorkflowEditGeneralConfigurationPermissionsGetter
		),
		hasWorkflowDeletePermissions: getter<(workflowId: WorkflowId) => boolean>(hasWorkflowDeletePermissionsGetter),
		hasWorkflowEditPermissions: getter<(workflowId: WorkflowId) => boolean>(hasWorkflowEditPermissionsGetter),
		isLoadingWorkflowGraph: getter<boolean>(isLoadingWorkflowGraph),
		canEditWorkflow: getter<(workflowId: WorkflowId) => boolean>(canEditWorkflow),
	};
};
